import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import * as resActions from "../../modules/resources";
import * as sessionActions from "../../modules/session";
import PropTypes from "prop-types";
import { alertSuccess } from "../../utils/alerts";
import QboxmailApi from "../../qboxmailApi";
import withFormState from "Components/withFormState";
import { formatServerErrors } from "Utils/serverFormats";
import { t } from "i18next";
import Stepper from "Components/stepper2/Stepper";
import Plan from "./add_form/Plan";
import Basic from "./add_form/Basic";
import Profile from "./add_form/Profile";
import Services from "./add_form/Services";
import Security from "./add_form/Security";
import { quotas, humanQuotas } from "@/config";

const ContextTypes = {
  isLoggedUserTrial: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
};

const formInitialState = {
  name: "",
  postmaster_password: "",
  postmaster_password_confirmation: "",
  customer_code: "",
  imap_disabled: false,
  pop_disabled: false,
  smtp_disabled: false,
  webmail_disabled: false,
  max_email_accounts_50gb: -1,
  max_email_accounts_100gb: -1,
  max_email_accounts_25gb: -1,
  max_email_accounts_archive: -1,
  max_email_accounts: -1,
  max_email_quota: humanQuotas["25GB"],
  default_quota: humanQuotas["25GB"],
  allow_nets: [],
  plan: undefined,
  language: "it",
  timezone: "Europe/Rome",
  dav: true,
  activesync: true,
  api_enabled: false,
  force_otp: false,
  password_change_disabled: false,
  password_recovery_disabled: false,
  password_expiration: -1,
  force_password_first_login: false,
  block_old_password: false,
  destroy_sessions_on_password_expiration: false,
};

class DomainNewScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      steps: {
        1: { component: <Plan /> },
        2: { component: <Basic /> },
        3: { component: <Profile /> },
        4: { component: <Services /> },
        5: { component: <Security /> },
      },
      selectedCustomer: null,
    };
  }

  componentDidMount() {
    // get the last info about the orders status if the user is annually
    if (this.context.getLoggedUser()?.orders?.[0]?.billing_cycle === "annually") {
      this.props.refreshLoggedUserData();
    }

    if (this.context.isLoggedUserTrial()) {
      this.props.setFormFieldValue({
        max_email_quota: humanQuotas["8GB"],
        default_quota: humanQuotas["8GB"],
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const current = this.state.selectedCustomer;
    const prev = prevState.selectedCustomer;

    if (current && prev?.code !== current?.code) {
      if (current.plan === "trial") {
        this.props.setFormFieldValue({
          max_email_quota: humanQuotas["8GB"],
          default_quota: humanQuotas["8GB"],
        });
      } else {
        this.props.setFormFieldValue({
          max_email_quota: humanQuotas["25GB"],
          default_quota: humanQuotas["25GB"],
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  selectCustomer = (customer) => {
    this.setState({ selectedCustomer: customer });
  };

  goToStep = (no) => {
    this.setState({ currentStep: no });
  };

  goBack = () => {
    if (this.state.currentStep <= 1) return;
    this.setState({ currentStep: this.state.currentStep - 1 });
  };

  showStepNumber = (no) => {
    return this.state.steps[no];
  };

  returnToList() {
    this.props.history.push({
      pathname: "/domains",
    });
  }

  submitForm = () => {
    this.props.setFormLoading();
    const formData = _.clone(this.props.formData);
    const api = new QboxmailApi({ useCookie: true });

    if (formData.max_email_quota < formData.default_quota) {
      formData.default_quota = formData.max_email_quota;
    }

    if (formData.allow_nets.length === 0) delete formData.allow_nets;
    api
      .createDomain(formData)
      .then(() => {
        this.props.refreshDomains();
        alertSuccess(t("alert.domainCreatedSuccess"));
        this.returnToList();

        this.props.refreshLoggedUserData();
      })
      .catch((response) => {
        formatServerErrors(response).then((errors) => {
          // Show the errors in the last step
          let onForm = {};

          if (errors.max_email_quota || errors.default_quota) {
            onForm = errors.max_email_quota;
          }

          if (Object.keys(onForm).length > 0) {
            this.props.setFormErrors({ onForm });
          } else {
            this.props.setFormErrors(errors);
          }

          this.props.unsetFormLoading();
        });
      });
  };

  resetAndGoBack = () => {
    this.props.resetForm();
    this.returnToList();
  };

  backToList = () => {
    this.props.history.push("/domains");
  };

  render() {
    let toShow = this.showStepNumber(this.state.currentStep);

    return (
      <div className="contentWrapper">
        {React.cloneElement(toShow.component, {
          ...this.props,
          goToStep: this.goToStep,
          submitForm: this.submitForm,
          onSuccess: () => this.onSuccess(),
          loggedUser: this.context.getLoggedUser(),
          loggedUserType: this.context.getLoggedUserType(),
          isloggedUserInTrial: this.context.isLoggedUserTrial(),
          isLoggedUserAdmin: this.context.isLoggedUserAdmin(),
          isReseller: this.context.getLoggedUser().is_reseller,
          backToList: this.backToList,
          stepper: <Stepper steps={5} active={this.state.currentStep} goBack={this.goBack} />,
          selectCustomer: this.selectCustomer,
          selectedCustomer: this.state.selectedCustomer,
        })}
      </div>
    );
  }
}

//DomainNewScreen.propTypes = propTypes;
DomainNewScreen.contextTypes = ContextTypes;

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  refreshDomains: (queryParams) => dispatch(resActions.callApi("refreshDomains", "domains", queryParams)),
  refreshLoggedUserData: () => {
    dispatch(sessionActions.verify(false));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withFormState(DomainNewScreen, formInitialState));
